
import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";

@Component
export default class UyapConnectionInfo extends Vue {
  @Getter isUyapConnected!: boolean;
  @Getter isDevMode!: boolean;
  @Action connectToUyap!: () => Promise<void>;
  @Getter isTokenExis!: boolean;

  get iconColor(): string {
    return this.isUyapConnected ? 'green' : 'white';
  }

  get tooltipText(): string {
    return this.isUyapConnected ? 'UYAP Bağlantısını yenile.' : "Uyap'a Bağlan";
  }

  handleAction(): void {
    if (this.isUyapConnected) {
      this.openUyap();
    } else {
      // Hata durumu store'da uyapStatusMessage olarak gösteriliyor;
      // burada sadece unhandled rejection engellenir.
      this.connectToUyap().catch((e: unknown) => console.error('UYAP bağlantısı başarısız.', e));
    }
  }

  openUyap(): void {
    this.$store.dispatch('openUyapWindow');
  }
}
